import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsSearchComponent } from './maps-search/maps-search.component';
import { MapsSearchService } from './maps-search.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MapsSearchComponent
  ],
  providers: [
    MapsSearchService
  ],
  exports: [MapsSearchComponent]
})
export class MapsSearchModule { }



// WEBPACK FOOTER //
// ./src/app/modules/maps-search/maps-search.module.ts